<template>
    <div id="app">
    <img src="../assets/logo.svg" class="app-logo">
        <h2>
         تقويمي، تقويم أم القرى
        </h2>
        <div>
          <a href='https://play.google.com/store/apps/details?id=ws.xsoh.taqwemee&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img class="google-play-badge" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
          </a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
#app{
  text-align: center;
  color:white;
}
.app-logo{
  height: 40vmin;
  pointer-events: none;
}

.google-play-badge{
  width: 30vmin;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue